import { useContext, useEffect, useState } from 'react';

import { Col, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';

import Loader from 'components/layout/Loader';
import InputControl from 'components/inputs/InputControl';
import InputDate from 'components/inputs/InputDate';
import Switchrs from 'components/inputs/Switchrs';
import InputClock from 'components/inputs/InputClock';
import hocFrom from 'components/forms/HocFrom';
import DashboardContext from 'Context';
import InputControlAsync from 'components/inputs/InputControlAsync';
import toaster from 'helper/toaster';

const FormLeave = ({
  handelUpdataFrom,
  handelSend,
  loding,
  handelLoadingform,
  LoadingForm,
  dataUpdate,
  handelsetdataForm,
  formdata,
  onTheList = false,
}) => {
  const { idview, Workername } = useContext(DashboardContext);
  const [dataClock, setDataClock] = useState({
    isHourly: false,
    startClock: '',
    EndClock: '',
  });
  const data = dataUpdate;
  useEffect(() => {
    setDataClock({
      isHourly: data?.isHourly,
      startClock: data?.startDate?.slice(11, 16) || '',
      EndClock: data?.endDate?.slice(11, 16) || '',
    });
  }, [dataUpdate]);

  const handelValue = (name, value) => {
    switch (name) {
      case 'leaveType':
        if (dataUpdate.workerId) {
          handelsetdataForm({
            ...formdata,
            leaveType: parseInt(value),
            workerId: dataUpdate.workerId,
          });
        } else {
          handelsetdataForm({
            ...formdata,
            leaveType: parseInt(value),
            workerId: formdata?.workerId
              ? formdata?.workerId
              : JSON.parse(sessionStorage.getItem('workerId'))
              ? JSON.parse(sessionStorage.getItem('workerId'))
              : idview,
          });
        }
        break;
      case 'startDate':
        const clockstart = formdata.startDate
          ? formdata.startDate.substr(11, 16)
          : '00:00';
        handelsetdataForm({ ...formdata, startDate: `${value}T${clockstart}` });
        break;
      case 'endDate':
        const clockEnd = formdata.endDate
          ? formdata.endDate.substr(11, 16)
          : '00:00';

        handelsetdataForm({ ...formdata, endDate: `${value}T${clockEnd}` });
        break;
      case 'description':
        handelsetdataForm({ ...formdata, description: value });
        break;
      case 'expertToWorkerDescription':
        handelsetdataForm({ ...formdata, expertToWorkerDescription: value });
        break;
      case 'expertToExpertDescription':
        handelsetdataForm({ ...formdata, expertToExpertDescription: value });
        break;
      case 'isActive':
        // setdefaultActive(value)
        handelsetdataForm({ ...formdata, isActive: true });
        break;

      case 'isHourlyFormLeave':
        setDataClock({ ...dataClock, isHourly: value });
        handelsetdataForm({ ...formdata, isHourly: value });
        break;
      case 'startClock':
        const lastdataStartDate = formdata.startDate
          ? formdata.startDate.substr(0, 10)
          : '';
        setDataClock({ ...dataClock, startClock: value });
        handelsetdataForm({
          ...formdata,
          startDate: `${lastdataStartDate}T${value}`,
        });
        break;
      case 'EndClock':
        const lastdataEndDate = formdata.endDate
          ? formdata.endDate.substr(0, 10)
          : '';
        setDataClock({ ...dataClock, EndClock: value });
        handelsetdataForm({
          ...formdata,
          endDate: `${lastdataEndDate}T${value}`,
        });
        break;
      case 'leaveStatus':
        handelsetdataForm({ ...formdata, leaveStatus: value });
        break;
      case 'workerId':
        handelsetdataForm({ ...formdata, workerId: value });
        break;
      default:
        break;
    }
  };

  const handelSubmit = async (event) => {
    event.preventDefault();
    dataUpdate.isActive = true;
    handelLoadingform(true);

    if (onTheList && !dataUpdate?.workerId && !formdata?.workerId) {
      return toaster.error('لطفا نیروی مورد نظر را انتخاب کنید.');
    }

    if (formdata?.startDate > formdata?.endDate) {
      return toaster.error('تاریخ پایان باید بزرگتر باشد.');
    }

    if (!formdata.leaveType) {
      toast.error('لطفا نوع مرخصی را انتخاب کنید', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      handelLoadingform(false);
    } else if (!formdata.startDate) {
      toast.error('لطفا روز شروع مرخصی را انتخاب کنید', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      handelLoadingform(false);
    } else if (!formdata.endDate) {
      toast.error('لطفا روز پایان مرخصی را انتخاب کنید', {
        position: 'bottom-left',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      handelLoadingform(false);
    } else if (dataClock.isHourly) {
      if (!dataClock.startClock) {
        toast.error('لطفا ساعت شروع مرخصی را انتخاب کنید', {
          position: 'bottom-left',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        handelLoadingform(false);
      } else if (
        !dataClock.EndClock ||
        dataClock.EndClock === '00:00' ||
        formdata?.endDate?.slice(11, 16) === '00:00'
      ) {
        toast.error('لطفا ساعت پایان مرخصی را انتخاب کنید', {
          position: 'bottom-left',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        handelLoadingform(false);
      } else if (parseInt(dataClock.startClock.slice(0, 2)) > 22) {
        toast.error('ساعت شروع نباید دیرتر از 22:00 باشد', {
          position: 'bottom-left',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        handelLoadingform(false);
      }
      if (dataClock.startClock?.slice(0, 2) >= dataClock.EndClock.slice(0, 2)) {
        toast.error('ساعت پایان باید از ساعت شروع جلوتر باشد', {
          position: 'bottom-left',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        handelLoadingform(false);
      } else {
        dataUpdate.workerId ? handelUpdataFrom() : handelSend();
      }
    } else {
      dataUpdate.workerId ? handelUpdataFrom() : handelSend();
    }
  };
  //console.log(formdata);
  //console.log(formdata.isHourly ? false : true);
  return (
    <>
      {loding ? (
        <Loader />
      ) : (
        <Form>
          <Form.Row>
            {!dataUpdate?.workerId && onTheList ? (
              <Col>
                <InputControlAsync
                  url='/worker/search'
                  name='workerId'
                  label='نام نیرو'
                  handelValue={handelValue}
                />
              </Col>
            ) : (
              <Col className='d-flex align-items-center justify-content-center'>
                <p>نام و نام خانوادگی : </p>
                <p>
                  {' '}
                  {dataUpdate.workerId
                    ? dataUpdate.workerName
                    : Workername}{' '}
                </p>
              </Col>
            )}
            <Col>
              <InputControl
                hasDefValueOnPurpose
                label='نوع مرخصی'
                url='/leave/leavetypedropdown'
                name='leaveType'
                handelValue={handelValue}
                defaultValue={dataUpdate.leaveType}
              />
            </Col>
          </Form.Row>
          <Form.Row>
            <Col>
              <InputDate
                label='تاریخ شروع'
                Placeholder='تاریخ شروع'
                name='startDate'
                handelValue={handelValue}
                defaultValue={
                  dataUpdate.hasOwnProperty('startDate')
                    ? dataUpdate.startDate.split('T')[0]
                    : ''
                }
              />
            </Col>
            <Col>
              <InputDate
                label='تاریخ پایان'
                Placeholder='تاریخ پایان'
                name='endDate'
                handelValue={handelValue}
                defaultValue={
                  dataUpdate.hasOwnProperty('endDate')
                    ? dataUpdate.endDate.split('T')[0]
                    : ''
                }
              />
            </Col>
            {dataUpdate.workerName ? (
              <Col>
                <InputControl
                  url='/leave/leavestatusdropdown'
                  name='leaveStatus'
                  label='تعیین مرخصی'
                  defaultValue={dataUpdate.leaveStatus}
                  handelValue={handelValue}
                />
              </Col>
            ) : null}
          </Form.Row>
          <Form.Row>
            <Col>
              <div className='form-group'>
                <label for='descriptionTextarea'>توضیحات نیرو برای کارشناس</label>
                <textarea
                  className='form-control'
                  id='descriptionTextarea'
                  rows='3'
                  defaultValue={dataUpdate ? dataUpdate.description : ''}
                  onChange={(e) => handelValue('description', e.target.value)}
                ></textarea>
              </div>
            </Col>
          </Form.Row>
          <Form.Row>
            <Col>
              <div className='form-group'>
                <label for='expertToWorkerDescriptionTextarea'>توضیحات کارشناس برای نیرو</label>
                <textarea
                  className='form-control'
                  id='expertToWorkerDescriptionTextarea'
                  rows='3'
                  defaultValue={dataUpdate ? dataUpdate.expertToWorkerDescription : ''}
                  onChange={(e) => handelValue('expertToWorkerDescription', e.target.value)}
                ></textarea>
              </div>
            </Col>
          </Form.Row>
          <Form.Row>
            <Col>
              <div className='form-group'>
                <label for='expertToExpertDescriptionTextarea'>توضیحات کارشناس برای کارشناس</label>
                <textarea
                  className='form-control'
                  id='expertToExpertDescriptionTextarea'
                  rows='3'
                  defaultValue={dataUpdate ? dataUpdate.expertToExpertDescription : ''}
                  onChange={(e) => handelValue('expertToExpertDescription', e.target.value)}
                ></textarea>
              </div>
            </Col>
          </Form.Row>
          <Form.Row className='mb-3 mt-2'>
            <Switchrs
              label='آیا مرخصی ساعتی است ؟'
              name='isHourlyFormLeave'
              handelValue={handelValue}
              checke={
                formdata.hasOwnProperty('isHourly') ? formdata.isHourly : false
              }
            />
          </Form.Row>
          <Form.Row>
            <Col>
              <InputClock
                HourTime='start'
                handelValue={handelValue}
                label='ساعت شروع'
                defaultValue={
                  dataUpdate.hasOwnProperty('startDate')
                    ? dataUpdate.startDate.split('T')[1]
                    : dataClock.startClock
                }
                disabled={formdata.isHourly ? false : true}
                name='startClock'
              />
            </Col>
            <Col>
              <InputClock
                HourTime='end'
                handelValue={handelValue}
                label='ساعت پایان'
                defaultValue={
                  dataUpdate.hasOwnProperty('endDate')
                    ? dataUpdate.endDate.split('T')[1]
                    : dataClock.EndClock
                }
                disabled={formdata.isHourly ? false : true}
                name='EndClock'
              />
            </Col>
          </Form.Row>
          <Form.Row>
            <Col>
              <button
                type='submit'
                className='btn btn-success'
                onClick={handelSubmit}
                disabled={LoadingForm}
              >
                {LoadingForm ? (
                  <i className='fa fa-spinner fa-pulse fa-fw'></i>
                ) : dataUpdate.workerId ? (
                  'ثبت ویرایش'
                ) : (
                  'ثبت'
                )}
              </button>
            </Col>
          </Form.Row>
        </Form>
      )}
    </>
  );
};

export default hocFrom(FormLeave);
